// Radiation units with conversion factors to sievert (Sv)
export const radiationUnits = [
  { id: 'sievert', name: 'Sievert', symbol: 'Sv', plural: 'Sieverts', factor: 1 },
  { id: 'millisievert', name: 'Millisievert', symbol: 'mSv', plural: 'Millisieverts', factor: 1e-3 },
  { id: 'microsievert', name: 'Microsievert', symbol: 'µSv', plural: 'Microsieverts', factor: 1e-6 },
  { id: 'rem', name: 'Rem', symbol: 'rem', plural: 'Rems', factor: 0.01 },
  { id: 'millirem', name: 'Millirem', symbol: 'mrem', plural: 'Millirems', factor: 1e-5 },
  { id: 'joule-per-kilogram', name: 'Joule/Kilogram', symbol: 'J/kg', plural: 'Joules/Kilogram', factor: 1 },
  { id: 'gray', name: 'Gray', symbol: 'Gy', plural: 'Grays', factor: 1 },
  { id: 'milligray', name: 'Milligray', symbol: 'mGy', plural: 'Milligrays', factor: 1e-3 },
  { id: 'microgray', name: 'Microgray', symbol: 'µGy', plural: 'Micrograys', factor: 1e-6 },
  { id: 'rad', name: 'Rad', symbol: 'rad', plural: 'Rads', factor: 0.01 },
];

export const popularRadiationConversions = [
  { from: 'sievert', to: 'rem' },
  { from: 'rem', to: 'sievert' },
  { from: 'sievert', to: 'millisievert' },
  { from: 'millisievert', to: 'microsievert' },
  { from: 'gray', to: 'rad' },
  { from: 'rad', to: 'gray' },
];

export const getUnitById = (id) => radiationUnits.find(unit => unit.id === id);

export const convertRadiation = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert radiation dose equivalent units and learn the conversion formula.`;
};
